<template>
  <el-row class="p-2">

    <!-- Controls -->
    <el-col :span="8" class="px-4 py-2">
      <div>
        <span style="font-weight:bold;">Order Session ID:</span> {{ orderSessionId }}
      </div>
      <br><br>

      <el-form ref="form" :model="form" label-width="120px">
        <el-form-item label="子訂單JSON">
          <el-input type="textarea" rows="8" v-model="form.suborder"></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="submitNewSuborder">提交子訂單</el-button>
        </el-form-item>
      </el-form>

      <!-- Preview as cURL -->
      <el-card shadow="never"
        :body-style="{
          background: '#F2F6FC', color: '#606266',
          'font-size': '8px',
          'word-wrap': 'break-word',
          'font-family': 'Courier New, Courier, monospace'
        }">
        <span>
          curl -X POST -H "Content-Type: application/json"
          <br>
          -d '{{ form.suborder }}'
          <br>
          "{QC-APIS_HOST_API}/pub/parties/{{ orderSessionId }}/suborders"
        </span>
      </el-card>

    </el-col>

    <!-- Suborders and their content -->
    <el-col :span="16">

      <!-- Accordion -->
      <el-card shadow="never">

        <div v-if="!suborders.length">
          這個Order Session尚無任何子訂單。可於左側表單新增。
        </div>

        <el-collapse v-else>

          <el-collapse-item v-for="so in suborders" v-bind:key="so.id"
            :title="`訂購人：${so.userName}`" :name="so.id">
            <ProductsDemoComp :orderSessionId="orderSessionId" :suborderId="so.id" />
            <br>
            <el-button type="warning" @click="deleteSuborder(so.id)">刪除此子訂單</el-button>
          </el-collapse-item>

        </el-collapse>
      </el-card>

    </el-col>

  </el-row>

</template>

<script>
import ProductsDemoComp from './ProductsDemoComp.vue';

import axios from 'axios';
import { fsdb } from '../../firestore';//NOTE: 這個來源.js中初始化了前端Firebase JS SDK，並引出了Firestore (fsdb) 物件。

export default {
  components: {
    ProductsDemoComp//NOTE: 須用另一個子component來bind "products" array.
  },
  
  mounted() {
    this.orderSessionId = this.$route.query.orderSessionId;
    if (!this.orderSessionId) {
      alert(`示範功能用頁面。\n請在URL query string帶上Order Session ID。\n例：?orderSessionId=XXXXXX`);
      return;
    }

    this.loadOrderSession();
  },

  methods: {

    loadOrderSession() {
      // NOTE: 用 this.$bind 可綁定某Firestore path給某local變數。local變數就會即時與該Firestore中的data同步變動。
      this.$bind('suborders', fsdb.collection(`parties/${this.orderSessionId}/suborders`));
    },

    submitNewSuborder() {
      axios.post(
        `${process.env.VUE_APP_APIHOST}/pub/parties/${this.orderSessionId}/suborders`,
        JSON.parse(this.form.suborder)
      )
      .then(response => {

      })
      .catch(err => {
        
      });
    },

    deleteSuborder(_id) {
      axios.delete(
        `${process.env.VUE_APP_APIHOST}/pub/parties/${this.orderSessionId}/suborders/${_id}`
      )
      .then(response => {

      })
      .catch(err => {
        
      });
    }

  },

  data() {
    return {
      orderSessionId: '',
      suborders: [],//NOTE: To be used with this.$bind(...)

      form: {
        suborder: '{"shopId":"pbeDLwMDM","userInfo":{"userPhone":"+886932918257","userAddress":"","userName":"Pin Chen","userEmail":"service@quickclick.cc"},"cartProducts":[{"productId":4729,"isDailyNumber":1,"isVisibled":1,"numOfRemain":12,"numOfProduct":12,"productName":"綠森林","productImage":"https://storage.googleapis.com/qc_staging_products/library/50/phone-1585737295170.jpg","productDescription":"","productAmount":300,"addons":[],"addonAmt":0,"addonStr":"","qty":2}],"totalAmount":600,"numOfProduct":1,"businessInfo":{"businessId":"","businessName":"","businessEmail":"","businessAddress":"","businessPhone":"","isEatIn":false,"isToGo":false,"isDelivery":false,"shopName":""},"discounts":{"common":{"value":0,"text":""},"coupon":{"value":0,"text":""}},"waitingTime":"10","loginTime":"2020-07-20 11:25:37","expiredTime":"2020-07-20 11:35:37","tableNumber":"","shopName":"快一點食堂dev","userId":"1","accountId":50,"accountEnabled":1,"source":""}'
      }
    };
  },

  computed: {

  }
  
}
</script>

<style scoped>

</style>